import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Pin } from 'lucide-react';
import { apiFetch } from '../fetchInterceptor';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Renders quick-access chips for folders pinned to this contact.
 * Hidden completely when there are no pinned folders.
 */
export default function PinnedFolderChips({ contactId, workspaceId }) {
  const navigate = useNavigate();
  const [folders, setFolders] = useState([]);

  const fetchPinned = useCallback(async () => {
    if (!contactId) return;
    try {
      const r = await apiFetch(`${API_URL}/api/contacts/${contactId}/pinned-folders`);
      if (r.ok) setFolders(await r.json());
    } catch (e) { console.error(e); }
  }, [contactId]);

  useEffect(() => { fetchPinned(); }, [fetchPinned]);

  if (!folders.length) return null;

  const goTo = (f) => {
    const space = f.space || 'firm';
    navigate(`/documents?space=${space}&folder=${f.folder_id}`);
  };

  return (
    <div className="mt-3 flex items-start gap-2 flex-wrap" data-testid="pinned-folder-chips">
      <div className="flex items-center gap-1 text-[11px] text-muted-foreground uppercase tracking-wide font-medium pt-1">
        <Pin className="w-3 h-3 text-rose-500" />
        Pinned
      </div>
      <div className="flex flex-wrap gap-1.5">
        {folders.map(f => (
          <button
            key={f.folder_id}
            onClick={() => goTo(f)}
            className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border bg-card hover:bg-muted text-xs transition-colors"
            style={{ borderColor: f.color ? `${f.color}55` : undefined }}
            data-testid={`pinned-chip-${f.folder_id}`}
            title={f.path || f.name}
          >
            <span
              className="w-1.5 h-1.5 rounded-full flex-shrink-0"
              style={{ background: f.color || '#3b82f6' }}
            />
            <span className="truncate max-w-[160px]">{f.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
